'use client';

import React from 'react';
import ContactHero from './ContactHero';
import ProductInquiryForm from './ProductInquiryForm'; // Updated name
// import HQLocation from './HQLocation'; // Updated name
import { ContactInfo } from './ContactInfo';
import DigitalCard from './DigitalCard';

const ContactInteractive: React.FC = () => {
  return (
    <>
      <section className="py-12 lg:py-16 bg-background">
        <ContactHero
          title="Connect with Flora Dine"
          subtitle="Whether for wholesale orders, custom designs, or sustainability questions, we're here to help you go green."
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <ProductInquiryForm />
            </div>
            <div>
              <ContactInfo />
            </div>
          </div>
        </div>
      </section>

      {/* Story flow: get in touch (form + info) → save our card → where we are → answer objections */}
      <DigitalCard />
    </>
  );
};

export default ContactInteractive;
